import { PlanGroup } from '@d-id/types';

export const DISCOUNT = 30;
export const DISCOUNT_FACTOR = 0.7; // to reduce DISCOUNT percentage

export const minAmountVideosPerMonthForDiscountByPlanGroup = (planGroup: PlanGroup | undefined) => {
    if (planGroup === PlanGroup.LITE) {
        return 8;
    } else if (planGroup === PlanGroup.PRO) {
        return 11;
    } else if (planGroup === PlanGroup.ADVANCED) {
        return 15;
    } else {
        return Infinity;
    }
};

export const monthlyToYearlyCoupon = {
    id: 'TGoTFsYK',
    name: '30% off annual',
    promoCode: '',
};
